import esES from 'antd/es/locale/es_ES';
import enUS from 'antd/es/locale/en_US';
import enGB from 'antd/es/locale/en_GB';

export const antdLocaleMap: Record<string, any> = {
  es: esES,
  mx: esES,
  gb: enGB,
  us: enUS,
};
